import { useAddDepensesMutation } from "actions/depenses/mutations";
import { useGetFournisseurQuery } from "actions/fournisseurs/queries";
import { useCreateFournisseurMutation } from "actions/fournisseurs/mutations";
import { useAddProduitMutation } from "actions/produits/mutations";
import { useGetProduitsQuery } from "actions/produits/queries";
import ProductModal from "components/AddProducts/ProductModal";
import ProductForm from "components/ProductForm/ProductForm";
import AutocompleteSelect from "components/AutocompleteSelect/AutocompleteSelect";
import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import HeaderFirst from "utils/HeaderFirst";
import FileUpload from "./FileUpload";
import "./style.css";
import { useGetComptePaiementQuery } from 'actions/compte_paiement/queries';
import { useGetCodesQuery } from "actions/comptabilite/queries";
import { toastApiErrors } from "utils/toastApiError";

export default function AddDepensesForm() {
  const { clientID: dossier_id } = useParams();
  const { data: getProduitData, refetch: refetchProduits } = useGetProduitsQuery({ dossier_id });
  const navigate = useNavigate();
  const { data: fournisseurResponse, isLoading: isLoadingFournisseurs, refetch: refetchFournisseurs } =
    useGetFournisseurQuery({ dossier_id: dossier_id });
  const [createFournisseur] = useCreateFournisseurMutation();

  console.log("Mes codes getProduitData:", getProduitData);  
  
  const {data: compte_paiement } = useGetComptePaiementQuery({dossier_id})
  const { data: codesData } = useGetCodesQuery({ dossier_client: dossier_id });

  // Comptes proposables pour un achat : classe 6 (charges) + classe 2 (immobilisations)
  const rawCodes = Array.isArray(codesData)
    ? codesData
    : codesData?.data || codesData?.results || [];
  const accountOptions = rawCodes
    .filter((c) => {
      const s = String(c.code ?? "");
      return s.startsWith("6") || s.startsWith("2");
    })
    .map((c) => ({ id: Number(c.code), nom: c.combine || `${c.code} - ${c.libelle}` }));
  const [addDepense, { isLoading: isSubmittingDepense }] = useAddDepensesMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const productFormMethods = useForm();
  const [creationProduit, { isSuccess }] = useAddProduitMutation();


  // ← AJOUT 1 : état mode de règlement
  const [modeReglement, setModeReglement] = useState("comptant");
  const lastAutoFilledIntitule = useRef("");

  const [depense, setDepense] = useState({
    fournisseur: null,
    intitule: "",
    dossier_id: dossier_id,
    facturable_au_client: false,
    taxes: 0,
    prix: 0,
    somme_payee: 0,
    remise: 0,
    quantite: 1,
    description: "",
    crm: "",
    source_paiement: "",
    date_transaction: "",
    produits_associes: [{ produit: null, prix: null, quantite: 1 }],
  });

  const taxesOptions = {
    0: "0%",
    10: "10%",
    18: "18%",
  };

  const handleAddProduct = () => {
    setShowProductModal(true);
  };

  const handleCreateProduct = async (nom) => {
    try {
      const produitData = {
        nom: nom,
        dossier_id: dossier_id,
        prix: 0,
        quantite: 1,
        genre_transaction: "sortie",
      };
      const result = await creationProduit(produitData).unwrap();
      toast.success(`Produit "${nom}" créé avec succès`);
      await refetchProduits();
      return result;
    } catch (error) {
      console.error('Erreur création produit:', error);
      toast.error('Erreur lors de la création du produit');
      throw error;
    }
  };

  // Fonction pour créer un nouveau fournisseur
  const handleCreateFournisseur = async (nom) => {
    try {
      const fournisseurData = {
        nom: nom,
        dossier_id: dossier_id,
        telephone: '',
        email: '',
        adresse: '',
        active: true,
        archived: false,
        compte_comptable: '40',  // Génère automatiquement le compte fournisseur
        lettrage: false
      };
      
      const result = await createFournisseur(fournisseurData).unwrap();
      toast.success(`Fournisseur "${nom}" créé avec succès`);
      await refetchFournisseurs();
      return result;
    } catch (error) {
      console.error('Erreur création fournisseur:', error);
      toast.error('Erreur lors de la création du fournisseur');
      throw error;
    }
  };

  const handleProductCreated = async (createdProduct) => {
    await refetchProduits();
    if (!createdProduct?.id) return;

    if (createdProduct?.nom && (!depense.intitule || depense.intitule === lastAutoFilledIntitule.current)) {
      setDepense((prev) => ({ ...prev, intitule: createdProduct.nom }));
      lastAutoFilledIntitule.current = createdProduct.nom;
    }

    setDepense((prev) => {
      const produits_associes = [...prev.produits_associes];
      const pendingIndex = produits_associes.findIndex(
        (p) => !p.produit || Number.isNaN(Number(p.produit))
      );
      const index =
        pendingIndex >= 0 ? pendingIndex : produits_associes.length - 1;

      produits_associes[index] = {
        ...produits_associes[index],
        produit: createdProduct.id,
        code_comptable: createdProduct.code_comptable || produits_associes[index]?.code_comptable,
      };

      return { ...prev, produits_associes };
    });
  };

  const handleProductChange = (index, event) => {
    const { name, value } = event.target;
    let updatedProduitsAssocies = [...depense.produits_associes];

    if (!updatedProduitsAssocies[index]) {
      updatedProduitsAssocies[index] = { produit: "", prix: "", quantite: 1 };
    }

    updatedProduitsAssocies[index][name] =
      name === "produit" ? Number(value) : value;

    // À la sélection d'un produit, pré-remplir le compte avec son code par défaut et l'intitulé
    if (name === "produit" && value && !Number.isNaN(Number(value))) {
      const prod = (getProduitData?.data || []).find((p) => p.id === Number(value));
      if (prod?.code_comptable) {
        updatedProduitsAssocies[index].code_comptable = prod.code_comptable;
      }
      if (prod?.nom && (!depense.intitule || depense.intitule === lastAutoFilledIntitule.current)) {
        setDepense((prev) => ({ ...prev, intitule: prod.nom }));
        lastAutoFilledIntitule.current = prod.nom;
      }
    }

    // À la sélection d'un compte comptable sur la ligne, mettre à jour l'intitulé si vide ou précédent
    if (name === "code_comptable" && value) {
      const digits = String(value).replace(/\D/g, "");
      const found = accountOptions.find((a) => String(a.id) === digits);
      const rawNom = found?.nom || "";
      const accountLabel = rawNom.includes(" - ") ? rawNom.split(" - ").slice(1).join(" - ").trim() : rawNom;
      if (accountLabel && (!depense.intitule || depense.intitule === lastAutoFilledIntitule.current)) {
        setDepense((prev) => ({ ...prev, intitule: accountLabel }));
        lastAutoFilledIntitule.current = accountLabel;
      }
    }

    if (value === "ajouterProduit") {
      handleAddProduct();
      return;
    }

    setDepense((prev) => ({ ...prev, produits_associes: updatedProduitsAssocies }));
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    setDepense((prevState) => {
      if (type === "checkbox") {
        return { ...prevState, [name]: checked };
      } else if (["fournisseur", "prix", "quantite", "taxes", "somme_payee"].includes(name)) {
        const intValue = value ? parseInt(value, 10) : "";
        return { ...prevState, [name]: intValue };
      } else {
        return { ...prevState, [name]: value };
      }
    });
  };

  const nom = <h4 className="titre-dossier">Ajouter une dépense</h4>;

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (file) => {
    setSelectedFile(file);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting || isSubmittingDepense) {
      return;
    }

    if (depense.taxes > 100) {
      toast.error("Les taxes ne peuvent pas dépasser 100%");
      return;
    }

    const requiredFields = ["fournisseur", "intitule", "description"];
    const areFieldsFilled = requiredFields.every(
      (field) => depense[field] && depense[field].toString().trim() !== "",
    );

    if (!areFieldsFilled || !depense.produits_associes.length) {
      toast.error("Tous les champs sont obligatoires.");
      return;
    }

    // Nettoyer code_comptable : garder uniquement les codes numériques
    const produitsAssociesClean = depense.produits_associes.map((p) => {
      const code = String(p.code_comptable ?? "").replace(/\D/g, "");
      return { ...p, code_comptable: code ? Number(code) : null };
    });

    let dataPayload = {
      fournisseurs: depense.fournisseur,
      intitule: depense.intitule,
      dossier_id: depense.dossier_id,
      facturable_au_client: depense.facturable_au_client,
      taxes: depense.taxes,
      description: depense.description,
      crm: depense.crm,
      source_paiement: depense.source_paiement,
      mode_reglement: modeReglement,
      produits_associes: produitsAssociesClean,
      prix: depense.prix,
      somme_payee: modeReglement === "credit" ? 0 : depense.somme_payee,
      remise: depense.remise,
      date_transaction: depense.date_transaction || null,
    };

    setIsSubmitting(true);
    try {
      if (selectedFile) {
        const formData = new FormData();

        formData.append("dossier_id", depense.dossier_id);
        formData.append("fournisseurs", depense.fournisseur);
        formData.append("intitule", depense.intitule);
        formData.append("facturable_au_client", depense.facturable_au_client);
        formData.append("taxes", depense.taxes);
        formData.append("description", depense.description);
        formData.append("crm", depense.crm);
        formData.append("source_paiement", depense.source_paiement);
        formData.append("mode_reglement", modeReglement);
        formData.append("compte_comptable", depense.compte_comptable);
        formData.append("piece_joint", selectedFile);
        formData.append("prix", depense.prix);
        formData.append("somme_payee", modeReglement === "credit" ? 0 : depense.somme_payee);
        formData.append("remise", depense.remise);
        formData.append("date_transaction", depense.date_transaction || "");

        depense.produits_associes.forEach((produit, index) => {
          if (produit.produit && produit.prix !== undefined) {
            formData.append(`produits_associes[${index}]produit`, produit.produit);
            formData.append(`produits_associes[${index}]prix`, produit.prix.toString());
            if (produit.quantite) {
              formData.append(`produits_associes[${index}]quantite`, produit.quantite.toString());
            }
            const code = String(produit.code_comptable ?? "").replace(/\D/g, "");
            if (code) {
              formData.append(`produits_associes[${index}]code_comptable`, code);
            }
          } else {
            console.error(`Missing required product details at index ${index}`, produit);
          }
        });

        await addDepense(formData).unwrap();
        toast.success("Dépense ajoutée avec succès");
        navigate(-1);
      } else {
        await addDepense(dataPayload, {
          headers: { "Content-Type": "application/json" },
        }).unwrap();
        toast.success("Dépense ajoutée avec succès");
        navigate(-1);
      }
    } catch (error) {
      console.error("Requête échouée:", error);
      toastApiErrors(error);
    } finally {
      setIsSubmitting(false);
    }
  };


  const addProduct = () => {
    setDepense((prevState) => ({
      ...prevState,
      produits_associes: [
        ...prevState.produits_associes,
        { produit: "", prix: "", quantite: 1 },
      ],
    }));
  };

  const removeProduct = (index) => {
    setDepense((prevState) => ({
      ...prevState,
      produits_associes: prevState.produits_associes.filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    if (isSuccess) {
      setShowProductModal(false);
    }
  }, [isSuccess]);

  // ← AJOUT 2 : répercussion somme_payee = prix si mode comptant
  useEffect(() => {
    var somme = 0;
    const total = depense.produits_associes.map((produit) => {
      somme += parseInt(produit.prix) * parseInt(produit.quantite);
      return somme;
    });

    const montant_TTC =
      total[total.length - 1] * (1 + (depense.taxes - depense.remise) / 100);

    setDepense((prev) => ({
      ...prev,
      prix: montant_TTC,
      ...(modeReglement === "comptant" && { somme_payee: montant_TTC }),
    }));
  }, [depense.produits_associes, depense.taxes, depense.remise, modeReglement]);

  return (
    <div
      style={{
        backgroundColor: "white",
        minHeight: "500px",
        borderRadius: "20px",
        padding: "15px",
      }}
    >
      <HeaderFirst nom={nom} />
      <div className="container-background w-100 w-md-75 px-0 px-md-5">
        <Container fluid className="container-style p-4 mb-5">
          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="d-flex flex-column align-items-center gap-5">
              <div className="w-100 d-flex flex-column gap-2">
                <Row className="row-gap-2">
                  <Col sm={6}>
                    <Form.Group controlId="formFournisseur">
                      <AutocompleteSelect
                        label="Fournisseur"
                        options={fournisseurResponse?.data || []}
                        value={depense.fournisseur}
                        onChange={(value) => {
                          setDepense(prev => ({ ...prev, fournisseur: value }));
                        }}
                        onCreateNew={handleCreateFournisseur}
                        placeholder="Saisissez ou sélectionnez un fournisseur"
                        disabled={isLoadingFournisseurs}
                        createText="Créer le fournisseur"
                        type="fournisseur"
                      />
                    </Form.Group>
                  </Col>

                  <Col sm={6}>
                    <Form.Group controlId="formIntitule">
                      <Form.Label className="mb-2">Intitulé</Form.Label>
                      <Form.Control
                        type="text"
                        name="intitule"
                        value={depense.intitule}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="row-gap-2">
                  <Col sm={6}>
                    <Form.Group controlId="formDateTransaction">
                      <Form.Label className="mb-2">Date de la transaction</Form.Label>
                      <Form.Control
                        type="date"
                        name="date_transaction"
                        value={depense.date_transaction}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      />
                    </Form.Group>
                  </Col>
                </Row>          
                <Row className="row-gap-2">
                  <Col sm={6}>
                    <Form.Group controlId="formSourcePaiement">
                      <Form.Label className="mb-2">Source de Paiement</Form.Label>
                      <Form.Control
                        as="select"
                        name="source_paiement"
                        value={depense.source_paiement}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      >
                        <option value="">- Choisissez -</option>
                        {compte_paiement?.data?.map((compte) => (
                          <option key={compte.id} value={compte.id}>
                            {compte.compte}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId="formTaxes">
                      <Form.Label className="mb-2">Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={depense.description}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="row-gap-2">
                  <Col sm={6}>
                    <Form.Group controlId="formTaxes">
                      <Form.Label className="mb-2">Taxes (%)</Form.Label>
                      <Form.Control
                        as="select"
                        name="taxes"
                        value={depense.taxes}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      >
                        <option value="">- Sélectionnez -</option>
                        {Object.entries(taxesOptions).map(([value, label]) => (
                          <option key={value} value={parseInt(value)}>
                            {label}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId="formRemise">
                      <Form.Label className="mb-2">Remise (%)</Form.Label>
                      <Form.Control
                        type="number"
                        name="remise"
                        value={depense.remise}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* ← AJOUT 3 : mode de règlement + montant payé conditionnel */}
                <Row className="row-gap-2">
                  <Col sm={12}>
                    <Form.Group>
                      <Form.Label className="mb-2" style={{ fontWeight: 600 }}>
                        Mode de règlement
                      </Form.Label>
                      <div style={{ display: "flex", gap: "24px", marginTop: "4px" }}>
                        {[
                          { value: "comptant", label: "Au comptant" },
                          { value: "credit", label: "À crédit" },
                        ].map((mode) => (
                          <label
                            key={mode.value}
                            style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px" }}
                          >
                            <input
                              type="radio"
                              name="modeReglement"
                              value={mode.value}
                              checked={modeReglement === mode.value}
                              onChange={() => {
                                setModeReglement(mode.value);
                                if (mode.value === "comptant") {
                                  setDepense((prev) => ({ ...prev, somme_payee: prev.prix }));
                                }
                              }}
                              style={{ accentColor: "#009688" }}
                            />
                            {mode.label}
                          </label>
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="row-gap-2">
                  {modeReglement === "credit" && (
                    <Col sm={6}>
                      <Form.Group controlId="formPrix">
                        <Form.Label className="mb-2">Montant payé</Form.Label>
                        <Form.Control
                          type="number"
                          name="somme_payee"
                          value={depense.somme_payee}
                          onChange={handleInputChange}
                          className="rounded rounded-pill"
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col sm={6}>
                    <Form.Group controlId="formPrix">
                      <Form.Label className="mb-2">Total dû</Form.Label>
                      <Form.Control
                        type="number"
                        name="prix"
                        value={depense.prix}
                        onChange={handleInputChange}
                        className="rounded rounded-pill"
                        disabled={true}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {depense.produits_associes.map((product, index) => (
                      <ProductForm
                        key={index}
                        product={product}
                        index={index}
                        handleProductChange={handleProductChange}
                        removeProduct={removeProduct}
                        productOptions={getProduitData?.data}
                        totalProducts={depense.produits_associes?.length}
                        onCreateNewProduct={handleCreateProduct}
                        accountOptions={accountOptions}
                        showAccount
                      />
                    ))}
                    <Button
                      onClick={addProduct}
                      className="mt-3 rounded rounded-pill"
                      style={{ backgroundColor: "#068f7a", borderColor: "#068f7a" }}
                    >
                      Ajouter un produit
                    </Button>
                  </Col>
                </Row>
              </div>

              <Row>
                <Form.Group controlId="fileUploadControl" className="w-100">
                  <FileUpload onFileSelect={handleFileSelect} />
                </Form.Group>
              </Row>

              <Row className="mt-2">
                <Col sm={12} className="text-center">
                  <div className="d-flex gap-3">
                    <button
                      onClick={() => navigate(-1)}
                      className="btn btn-danger rounded rounded-pill px-4"
                    >
                      Annuler
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary rounded rounded-pill px-4 d-inline-flex align-items-center justify-content-center"
                      style={{ backgroundColor: "#068f7a", borderColor: "#068f7a" }}
                      disabled={isSubmitting || isSubmittingDepense || !depense.fournisseur || !depense.intitule || !depense.prix}
                    >
                      {(isSubmitting || isSubmittingDepense) && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {isSubmitting || isSubmittingDepense ? "Enregistrement..." : "Enregistrer"}
                    </button>

                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </Container>

        <ProductModal
          showModal={showProductModal}
          handleClose={() => setShowProductModal(false)}
          formMethods={productFormMethods}
          creationProduit={creationProduit}
          dossier_id={dossier_id}
          produits={getProduitData?.data}
          type="depense"
          onProductCreated={handleProductCreated}
        />
      </div>
    </div>
  );
}